import { Component, OnInit } from '@angular/core';
import { LocalStorageService } from '../../shared/services/local-storage.service';
import { KeyValuePipe, NgClass, NgForOf, NgIf, TitleCasePipe } from '@angular/common';
import { environment } from '../../../environments/environment';
import { ApiService } from '../../shared/services/api.service';
import { Airline } from '../../models/airline.model';
import { AgentAccessAccount } from '../../models/agent-access-account.model';
import { NgxSpinnerModule, NgxSpinnerService } from 'ngx-spinner';
import { catchError, finalize, forkJoin, of } from 'rxjs';
import { ConsumerData } from '../../models/consumer-data.modal';

@Component({
  selector: 'app-dashboard',
  imports: [TitleCasePipe, KeyValuePipe, NgForOf, NgIf, NgClass, NgxSpinnerModule],
  templateUrl: './dashboard.component.html',
  styleUrl: './dashboard.component.scss',
})
export class DashboardComponent implements OnInit {
  agencyName: string | null = null;
  agentAccounts: AgentAccessAccount[] = [];
  showAllAgents = false;
  airlines: { [code: string]: Airline } = {};
  loaded: boolean = false;
  consumerData!: ConsumerData;
  isSuperagency: boolean = false;

  constructor(
    private ls: LocalStorageService,
    private apiService: ApiService,
    private spinner: NgxSpinnerService
  ) {}

  ngOnInit() {
    this.agencyName = this.ls.getItem('agency');
    this.isSuperagency = this.ls.getBool('isSuperagency');
    this.loadAllDashboardData();
  }

  loadAllDashboardData(): void {
    this.loaded = false;
    this.spinner.show();

    forkJoin({
      agentAccounts: this.apiService.getAgentAccessAccounts().pipe(
        catchError(error => {
          console.error('Failed to load agent accounts:', error);
          return of([]);
        })
      ),
      airlines: this.apiService.getAirlines().pipe(
        catchError(error => {
          console.error('Failed to load airlines:', error);
          return of({});
        })
      ),
      consumerData: this.apiService.getConsumerData().pipe(
        catchError(error => {
          console.error('Failed to load consumer data:', error);
          return of({
            data: {
              city_code: '',
              currency_code: '',
              iata_number: '',
              agent_count: 0,
              agent_limit: 0,
              subagency_enabled: false,
              subagency_count: 0,
              subagency_limit: 0,
            },
          });
        })
      ),
    })
      .pipe(
        finalize(() => {
          this.loaded = true;
          this.spinner.hide();
        })
      )
      .subscribe(({ agentAccounts, airlines, consumerData }) => {
        this.agentAccounts = agentAccounts.filter(
          account => account.status === 'active' && account.role === 'manager'
        );
        this.airlines = airlines;

        this.consumerData = consumerData.data;
      });
  }

  toggleShowAll() {
    this.showAllAgents = !this.showAllAgents;
  }

  get visibleAgents(): AgentAccessAccount[] {
    return this.showAllAgents ? this.agentAccounts : this.agentAccounts.slice(0, 3);
  }

  redirectToBP(): void {
    window.open(environment.bpUrl, '_blank');
  }

  redirectToSupport(): void {
    window.open('https://support.airgateway.com/', '_blank');
  }
}
